import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.NoCompaniesPage.InvitationsList', {
    title: 'You have pending invitations to the following organisations',
    inviteDescription: 'Invitation from {name}',
    accept: 'Accept',
});
